import { useAppDispatch, useAppSelector } from "@/config/store";

import { Button, Card, Image, Typography, Spin, Upload, UploadFile, message, UploadProps, Row, Col, Modal, notification, Switch } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react";
import { clearRegistrationFile, deleteRegistrationFile, saveDraft, setRegistrationFile, updateRegistrationOCR } from '@/modules/onboarding/onboarding.reducer'
import Dragger from "antd/es/upload/Dragger";
import { CompanyBusinessRegistration } from "@/shared/model/company-business-registration.model";
import { useTranslation } from "react-i18next";
import { translations } from 'i18n/i18n';
import { extractName } from "@/shared/utils/jmix-rest/file";
import { useNavigate } from "react-router-dom";
import { useCheckDigitalSignMutation, useCheckSerialDigitalSignMutation, useExecuteOcrRegistrationMutation, useUploadFileRegistrationMutation } from "@/services/api/onboarding.api";
import axios from "axios";
import { userInfoApi } from "@/services/api/user-info.api";
const { Title, Text, Link } = Typography;
import { v4 as uuidv4 } from 'uuid';

import { Company, defaultValue } from '@/shared/model/company.model';
import { CompanyOnboardingRegisterEnum, DigitalSignStatusEnum, StatusEnum } from "@/shared/model/enums/enums";
import { fileApi } from "@/services/api/file.api";
import { NEW_CODE } from "@/config/config";

export default function UploadRegistration(props: any) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { onNext } = props
    const dispatch = useAppDispatch();

    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const companyEntity: Company = useAppSelector(state => state.onboarding.entity);
    const fileLoading: Company = useAppSelector(state => state.onboarding.fileLoading);
    const errorMessage: Company = useAppSelector(state => state.onboarding.errorMessage);
    const [downloadfileUpload, { data: pdfFlie, isLoading: isLoadingGetFile, isSuccess: isSuccessGetFlie, isError: isErrorGetFlie }] = fileApi.endpoints.downloadFile.useLazyQuery();
    const loadingOCRRegistration = useAppSelector(state => state.onboarding.loadingOCRRegistration);
    const [uploadFileRegistration, { data, isLoading, isSuccess, isError }] = useUploadFileRegistrationMutation()
    const [executeOcrRegistration, { data: dataCompany, isLoading: isLoadingOcr, isError: isErrorOcr, isSuccess: isSuccessOcr }] = useExecuteOcrRegistrationMutation()
    const [checkSerialDigitalSign, { data: serialDigitalSignValid, isLoading: loadingCheckSerialDigitalSign, isSuccess: successCheckSerialDigitalSign }] = useCheckSerialDigitalSignMutation()
    const [checkDigitalSign, { data: digitalSignValid, isLoading: loadingCheckDigitalSign, isSuccess: successCheckDigitalSign }] = useCheckDigitalSignMutation()
    const [clickCheckDigitalSign, setClickCheckDigitalSign] = useState(false)
    const [urlPDF, setUrlPDF] = useState<any>()
    // const [pdfData, setPdfData] = useState<string | null>(null);
    const [openModalReviewFile, setOpenModalReviewFile] = useState(false)
    const { businessRegistration } = companyEntity;

    const [buttonToTest, setButtonToTest] = useState(true)
    const [haveDigitalSign, setHaveDigitalSign] = useState(true)

    const onChangeHaveDigitalSign = (checked: boolean) => {
        setHaveDigitalSign(checked)
    };

    let companyEntityToTest: Company = useAppSelector(state => state.onboarding.entity);


    const digitalSign = haveDigitalSign
        ? {
            id: uuidv4(),
            hasOcr: true,
            signature: "Đã được xác minh",
            subject: "CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT2905",
            toDate: "30-06-2024 09:34:00",
            certificate: "Hợp lệ",
            taxCode: "0104128565",
            version: 2,
            issuer: "FPT Certification Authority",
            fromDate: "05-06-2020 09:34:00",
            ownerName: "CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT",
            serial: "540101041f4aa22e9461db27c108ddf7",
            digitalSignStatus: DigitalSignStatusEnum.success,
            signtime: "29-08-2021 19:35:23",
            validity: "Chứng thư số còn hạn tại thời điểm ký",
        }
        : {
            id: uuidv4(),
            hasOcr: false,
            signature: null,
            subject: null,
            // toDate: "30-06-2023 09:34:00",
            toDate: null,
            certificate: null,
            taxCode: null,
            issuer: null,
            fromDate: null,
            ownerName: null,
            serial: null,
            digitalSignStatus: DigitalSignStatusEnum.pending,
            signtime: null,
            validity: null,
        };

    const companyDefaultValues: Company = {
        id: uuidv4(),
        numberOfChangesRegistration: 21,
        charterCapital: "850000000000",
        businessRegistration: {
            id: uuidv4(),
            hasOcr: true,
            lastModifiedDate: "2024-03-18T10:23:14.932",
            docType: "Giấy chứng nhận đăng ký doanh nghiệp",
            lastModifiedBy: "nguyentienha0379@gmail.com",
            taxCode: "0104128565",
            version: 5,
            issueLocation: "SKHĐT",
            file: "minio://2024/03/18/4c892088-0158-7c76-2e4b-1bc6e19180da.pdf?name=Giay-dang-ky-kinh-doanh-FIS-lan-21_signed.pdf",
            jsonData: "{\"maSoDoanhNghiep\":\"0104128565\",\"loaiHinhDoanhNghiep\":\"công ty trách nhiệm hữu hạn\",\"ngayDangKy\":\"13/08/2009\",\"lanDangKy\":\"21\",\"ngayThayDoi\":\"28/03/2019\",\"tenDoanhNghiep\":\"CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT\",\"tenDoanhNghiepEn\":\"FPT INFORMATION SYSTEM CORPORATION\",\"tenDoanhNghiepVietTat\":\"FIS., CORP\",\"diaChi\":\"Tầng 22 tòa nhà Keangnam Landmark72, E6 đường Phạm Hùng, Phường Mễ Trì,  9 Quận Nam Từ Liêm, Thành phố Hà Nội, Việt Nam\",\"dienThoai\":\"84-4-35626000\",\"email\":\"contact@fis.com.vn\",\"fax\":\"84-4-35624850\",\"website\":\"www.fis.com.vn\",\"vonDieuLe\":\"850000000000\",\"menhGiaCoPhan\":\"\",\"tongSoCoPhan\":\"\",\"nguoiDaiDienPhapLuat\":[{\"hoVaTen\":\"DƯƠNG DŨNG TRIỀU\",\"gioiTinh\":\"Nam\",\"chucDanh\":\"Chủ tịch hội đồng thành viên\",\"ngaySinh\":\"10/06/1973\",\"quocTich\":\"Việt Nam\",\"loaiGiayTo\":\"CMND\",\"soGiayTo\":\"011674617\",\"ngayCap\":\"07/06/2007\",\"noiCap\":\"Công an Thành phố Hà Nội\",\"chiTietNoiDkHktt\":{\"country\":\"Việt Nam\",\"province\":\"Hà Nội\",\"street\":\"C9  Tập Thể Đại Hoc Xây Dựng  Tổ 3\",\"provinceCode\":\"101\",\"district\":\"Thanh Xuân\",\"ward\":\"Phương Liệt\"},\"noiDkHktt\":\"C9, Tập thể Đại hoc Xây Dựng, Tổ 3, Phường Phương Liệt, Quận Thanh Xuân, Thành phố Hà Nội, Việt Nam\",\"chiTietDiaChiTt\":{\"country\":\"Việt Nam\",\"province\":\"Hà Nội\",\"street\":\"E2301  Golden Westlake  Hoàng Hoa Thám\",\"provinceCode\":\"101\",\"district\":\"Ba Đình\",\"ward\":\"Ngọc Hà\"},\"diaChiTt\":\"E2301, Golden Westlake, Hoàng Hoa Thám, Phường Ngọc Hà, Quận Ba Đình, Thành phố Hà Nội, Việt Nam\",\"danToc\":\"Kinh\"}],\"noiCapDkkd\":\"SKHĐT\",\"chiTietDiaChi\":{\"country\":\"Việt Nam\",\"province\":\"Hà Nội\",\"street\":\"Tầng 22 Tòa Nhà Keangnam Landmark72  E6 Đường Phạm Hùng\",\"provinceCode\":\"101\",\"district\":\"Từ Liêm\",\"ward\":\"Mễ Trì\"},\"thanhVienGopVon\":{}}",
            createdDate: "2024-03-08T09:55:55.762",
            createdBy: "system"
        },
        isOnboardingSuccess: false,
        dateRegistration: "2009-08-13",
        fax: "84-4-35624850",
        bankAccount: [],
        hasRegisterGuarantee: true,
        isActived: true,
        nameEn: "FPT INFORMATION SYSTEM CORPORATION",
        mainAddress: {
            id: uuidv4(),
            address: "Tầng 22 tòa nhà Keangnam Landmark72, E6 đường Phạm Hùng, Phường Mễ Trì,  9 Quận Nam Từ Liêm, Thành phố Hà Nội, Việt Nam",
            createdDate: "2024-03-08T09:55:55.763",
            createdBy: "system",
            lastModifiedDate: "2024-03-11T17:08:52.06",
            lastModifiedBy: "nguyentienha0379@gmail.com",
            version: 2
        },
        version: 90,
        phoneNumber: "84-4-356260001",
        registrationType: "công ty trách nhiệm hữu hạn",
        hasRegisterLC: true,
        hasRegisterSCF: true,
        name: "CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT2905",
        digitalSign: digitalSign,
        status: StatusEnum.active,
        code: "0104128565",
        // onboardingStatus: CompanyOnboardingRegisterEnum.onboarding,
        legalRepresentative: {
            id: uuidv4(),
            birthday: null,
            cardIssueDate: "2022-01-01",
            cardFrontImage: null,
            faceImage: null,
            cardIssueLocation: "1",
            cardBackImage: null,
            cardNumber: null,
            email: null,
            phoneNumber: null,
            company: null,
            name: "1",
            cardID: "1",
        },
        email: "nguyentienha0379@gmail.com",
    };

    companyEntityToTest = {
        ...companyEntityToTest,
        ...companyDefaultValues
    }

    const handleModalOk = () => {
        setOpenModalReviewFile(false);
    };

    const handleModalCancel = () => {
        setOpenModalReviewFile(false);
    };


    const onDeleteFile = (e: any) => {
        let br: CompanyBusinessRegistration = companyEntity.businessRegistration as CompanyBusinessRegistration;
        const result: any = { ...companyEntity, ...{ businessRegistration: { file: null, hasOcr: false } } }
        dispatch(deleteRegistrationFile());
    }

    const onPreviewFile = async () => {
        // try {
        //     const response = await axios.get(urlPDF, {
        //         responseType: 'arraybuffer',
        //     });
        //     const pdfData = new Blob([response.data], { type: 'application/pdf' });
        //     setPdfData(URL.createObjectURL(pdfData));
        // } catch (error) {
        //     console.error('Error fetching PDF:', error);
        // }

        downloadfileUpload({ fileId: urlPDF, objectType: null })

        console.log("pdfFlie: " + pdfFlie)

        // if (pdfData) {
        //     URL.revokeObjectURL(pdfData);
        //     console.log("pdfData: ", pdfData)
        // }

        setOpenModalReviewFile(true)
    }

    const onSubmit = () => {
        if (buttonToTest) {
            if (!!businessRegistration?.file) {
                executeOcrRegistration(businessRegistration?.file)
            }
        }
        else {
            dispatch(updateRegistrationOCR(

                companyEntityToTest
                // id: "4f039ca4-966e-f95b-ade1-5510678a4d25",
                // subject: "CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT",
                // toDate: "04-06-2023 09:34:00",
                // taxCode: "0104128565",
                // issuer: "FPT Certification Authority",
                // fromDate: "05-06-2020 09:34:00",
                // ownerName: "CÔNG TY TNHH HỆ THỐNG THÔNG TIN FPT",
                // serial: "540101041f4aa22e9461db27c108ddf7",
                // digitalSignStatus: "SUCCESS",
                // signtime: "29-08-2021 19:35:23",

            ))
        }
    }

    const uploadProps: UploadProps = {
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            //   setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const isPdf = file.type === "application/pdf";
            if (!isPdf) {
                notification.error({
                    message:
                        (
                            <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                Bạn chỉ có thể tải định dạng PDF!
                            </div>
                        )
                });
                return
            }
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                notification.error({
                    message:
                        (
                            <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                File phải nhỏ hơn 20MB!
                            </div>
                        )
                });
                return
            }
            const formData = new FormData();
            formData.append("file", file);
            // dispatch(uploadFileRegistration(formData))
            uploadFileRegistration(formData);
            return
        },
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: 'Download',
            showRemoveIcon: true,
            removeIcon: <DeleteOutlined onClick={onDeleteFile} />,
        },
        fileList,
    };

    //succed update file ocr
    useEffect(() => {
        if (isSuccess) {
            console.log("HANT upload reg : ", data);
            setUrlPDF(data?.fileRef);
            dispatch(setRegistrationFile(data));

            // checkDigitalSign(data?.fileRef || "");
        }
    }, [isSuccess])

    // useEffect(() => {
    //     if (successCheckSerialDigitalSign) {
    //         checkDigitalSign(data?.fileRef || "");

    //     }
    // }, [checkSerialDigitalSign, loadingCheckSerialDigitalSign, successCheckSerialDigitalSign])

    // useEffect(() => {
    //     if (successCheckDigitalSign) {
    //         // console.log("digitalSignValid", digitalSignValid)
    //         if (digitalSignValid) {
    //             notification.info({ message: "File chưa được ký số!" })
    //             // let br: CompanyBusinessRegistration = companyEntity.businessRegistration as CompanyBusinessRegistration;
    //             // const result: any = { ...companyEntity, ...{ businessRegistration: { file: null, hasOcr: false } } }
    //             // dispatch(deleteRegistrationFile());
    //         }

    //         // else {
    //         //     notification.success({ message: "Giấy chứng nhận đăng ký kinh doanh hợp lệ!" })
    //         // }
    //     }
    // }, [successCheckDigitalSign])

    useEffect(() => {
        if (isSuccessOcr) {
            // console.log("1-------", dataCompany?.digitalSign)

            if (dataCompany?.digitalSign?.digitalSignStatus && (dataCompany?.digitalSign?.digitalSignStatus.toString() === "PENDING" || dataCompany?.digitalSign?.digitalSignStatus.toString() === "SUCCESS")) {
                // notification.info({ message: 'Giấy chứng nhận kinh doanh không hợp lệ!' })

                if (dataCompany.code) {
                    console.log(dataCompany.code)
                    console.log(companyEntity.code)
                    if (dataCompany.code === companyEntity.code) {
                        notification.success({
                            message:
                                (
                                    <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                        Nhận dạng file thành công!
                                    </div>
                                )
                        })
                        dispatch(updateRegistrationOCR(dataCompany))
                    }
                    else {
                        notification.error({
                            message:
                                (
                                    <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                        Mã số doanh nghiệp không khớp với thông tin đăng ký!
                                    </div>
                                )
                        })
                    }

                }
                else {
                    notification.error({
                        message:
                            (
                                <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                    Giấy chứng nhận kinh doanh không hợp lệ!
                                </div>
                            )
                    })
                }
            }
            else {
                notification.error({
                    message:
                        (
                            <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                                Nhận dạng file không thành công!
                            </div>
                        )
                })
            }
        }

        if (isErrorOcr) {
            notification.error({
                message:
                    (
                        <div style={{ fontWeight: 600, fontFamily: 'Lexend' }}>
                            Nhận dạng file không thành công!
                        </div>
                    )

            })
        }


    }, [isSuccessOcr, isErrorOcr])
    return (<Spin spinning={isLoadingOcr || loadingCheckDigitalSign || loadingCheckSerialDigitalSign}>
        <Content style={{
            display: 'flex',
            height: '80vh',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            {/* {NEW_CODE && <Button onClick={() => setButtonToTest(!buttonToTest)}>{buttonToTest.toString()}</Button>} */}

            {/* Chữ ký số<Switch defaultChecked onChange={onChangeHaveDigitalSign} /> */}

            <Col style={{ alignItems: 'center', justifyContent: 'center' }}>
                <Row style={{ alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
                    <Image style={{ alignSelf: 'center', display: 'flex' }} src="/images/z5435923995184_95a7a2bf652e4d2869a0b47ec7c869bd.jpg" preview={false} height={100} />
                </Row>
                <Row justify={'center'} style={{ marginBottom: 8 }}>
                    <Text strong style={{ fontSize: '1.5em', textAlign: 'center' }}>
                        {t(translations.onboarding.uploadRegistration.instruction)}
                    </Text>
                </Row>
                {/* <Row style={{ alignItems: 'center', justifyContent: 'center', marginBottom: 48 }}>
                    <Text style={{ fontSize: '1em', textAlign: 'center', color: '#1677ff' }}><span style={{ color: 'red' }}>*</span> {t(translations.onboarding.uploadRegistration.note)}</Text>
                </Row> */}
                <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
                    {!businessRegistration?.file ?
                        <Dragger {...uploadProps} style={{ width: '40vw', backgroundColor: '#F0F5FF', border: 'none' }}  >
                            <p className="ant-upload-drag-icon">
                                <img src="/images/Media style.png" />
                            </p>
                            <p className="ant-upload-text">{t(translations.onboarding.uploadRegistration.upload_click)}</p>
                            <p className="ant-upload-hint" >{t(translations.onboarding.uploadRegistration.upload_fomat)}  </p>
                        </Dragger>
                        :
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', backgroundColor: '#F0F5FF', padding: 5, borderRadius: 8 }}>
                            <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 10 }}>{extractName(businessRegistration?.file)}</div>
                            <div style={{ padding: 5 }}>
                                <Button disabled={isLoadingOcr} onClick={onPreviewFile} style={{ marginRight: 10 }}>{t(translations.action.view)}</Button>
                                <Button disabled={isLoadingOcr} onClick={onDeleteFile}>{t(translations.action.delete)}</Button>
                            </div>

                        </div>

                    }
                </Row>
                <Row style={{ textAlign: 'center', bottom: 10, width: '100%' }} justify={'center'}>
                    {!!businessRegistration && !!businessRegistration?.file && (
                        <Col>

                            <Row>
                                <Button type="primary" style={{ margin: '20px 8px', height: 40 }} onClick={() => onSubmit()}>
                                    {t(translations.action.ocr_file)}
                                </Button>
                            </Row>
                            {/* <Row>
                                {isLoadingOcr && <Spin spinning={isLoadingOcr} size="large">Đang thực hiện OCR</Spin>}
                            </Row> */}
                        </Col>
                    )}
                </Row>
            </Col>
            {/* <Footer style={{ textAlign: 'center', bottom: 10, width: '100%' }}>
                    
                </Footer> */}


            <Modal
                open={openModalReviewFile}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                title={"Xem chi tiết"}
                footer={(_, { OkBtn }) => (
                    <>
                        <Button onClick={handleModalCancel}>Đóng</Button>
                    </>
                )}
                width={'50vw'}
                centered={true}
            >
                {pdfFlie && (
                    <iframe
                        src={pdfFlie}
                        width="100%"
                        height="700px"
                        title="PDF Viewer"
                        frameBorder="0"
                    />
                )}
            </Modal>

        </Content >

    </Spin>)
}
